module.exports = __webpack_public_path__ + "media/images/icons/icon_fb-ac0c67ecdf0232829f2ef166c521102d.svg";